<template>
  <div class="login-wrap">
    <div class="header_logo">
        <el-image class="logo" :src="logo" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
        </el-image>
    </div>
    <div class="minddle">
        <div class="formBox" v-if="step==1?true:false">
              <div class="login_text">找回密码</div>
              <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
                  <el-form-item prop="username">
                    <el-input type="text" v-model="ruleForm.username" autocomplete="off" placeholder="请输入注册账号"></el-input>
                  </el-form-item>
                  <el-form-item class="codeImgText" prop="code">
                    <el-input type="text" placeholder="验证码" v-model="ruleForm.code">
                      <template slot="append">
                        <div  @click="refreshCode" class="codeImg">
                            <s-identify :identifyCode="identifyCode"></s-identify>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="nextfoot()">下一步</el-button>
                  </el-form-item>
              </el-form>
               <div class="textBox">
                 <a class="passtext" @click="$router.push('/login')">我已注册，去登录</a>
                  <el-divider direction="vertical"></el-divider>
                 <a class="creatText" @click="$router.push('/register')">立即注册</a>
              </div>
        </div>

         <div class="formBox" v-if="step==2?true:false">
              <div class="find_text">找回密码</div>
              <p style="font-size:16px;color:#888;margin-bottom:10px;">第二步：</p>
              <el-form :model="secondruleForm" status-icon :rules="rules" ref="secondruleForm" class="demo-ruleForm">
                  <el-form-item prop="username">
                    <el-input type="text" v-model="secondruleForm.username" disabled autocomplete="off" placeholder="请输入注册账号"></el-input>
                  </el-form-item>
                   <!-- <el-form-item label="" prop="newPass">
                            <el-input placeholder="请输入新密码"  type="password" v-model="secondruleForm.newPass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="checkPass">
                      <el-input placeholder="请确认密码"  type="password" v-model="secondruleForm.checkPass" autocomplete="off"></el-input>
                  </el-form-item> -->
                <el-form-item class="codeImgText" prop="captcha">
                  <!-- <el-input  v-model="ruleForm.code" autocomplete="off" placeholder="验证码"></el-input> -->
                  <el-input type="text" placeholder="验证码" v-model="secondruleForm.captcha" style="height: 45px">
                    <template slot="append">
                      <div  class="codeImg">
                        <img :src="verifyCode" @click="getVerifyCode" alt="验证码"
                             style="height: 45px; width: 156px; border-radius: 4px;">
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                  <el-form-item class="codePhoneText"  prop="codePhone">
                    <el-input type="text" placeholder="输入短信验证码" v-model="secondruleForm.codePhone">
                      <template slot="append">
                          <p class="getMessageText" @click="getsendSms" v-if="!isShowButton">获取短信验证码</p>
                          <p class="getMessageText" v-if="isShowButton">{{count}}秒后重新获取</p>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="secondfoot()">下一步</el-button>
                  </el-form-item>
              </el-form>
               <div class="textBox">
                 <a class="passtext" @click="$router.push('/login')">我已注册，去登录</a>
                  <el-divider direction="vertical"></el-divider>
                 <a class="creatText" @click="$router.push('/register')">立即注册</a>
              </div>
        </div>

         <div class="formBox" v-if="step==3?true:false">
              <div class="find_text">找回密码</div>
              <p style="font-size:16px;color:#888;margin-bottom:10px;">第三步：</p>
              <el-form :model="numberruleForm" status-icon :rules="rules" ref="numberruleForm" class="demo-ruleForm">
                   <el-form-item label="" prop="newPass">
                            <el-input placeholder="请输入新密码"  type="password" v-model="numberruleForm.newPass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="checkPass">
                      <el-input placeholder="请确认密码"  type="password" v-model="numberruleForm.checkPass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm()">修改密码</el-button>
                  </el-form-item>
              </el-form>
               <div class="textBox">
                 <a class="passtext" @click="$router.push('/login')">我已注册，去登录</a>
                  <el-divider direction="vertical"></el-divider>
                 <a class="creatText" @click="$router.push('/register')">立即注册</a>
              </div>
        </div>

      <div class="formBox" v-if="step==4?true:false">
        <div class="find_text">请选择</div>
        <el-form :model="selectedMerchantForm" status-icon :rules="rules" ref="selectedMerchantForm" class="demo-ruleForm">
          <el-form-item label="名称" prop="merchant">
            <el-select v-model="selectedMerchantForm.merchant" placeholder="请选择">
              <el-option
                v-for="item in merchantList"
                :key="item.merchantId"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirmMerchant()">确认选择</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <div class="footer_info">
        <p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}} <br>
          <a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
        </p>
    </div>
    <div style="align-items: center; text-align: center;display: flex; justify-content: center;">
      <el-image
        class="copyright_img"
        :src="require('@/assets/img/Nationa_Lemblem.png')"            style="margin-right: 5px;"
      ></el-image>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=46010002001073" rel="noreferrer" target="_blank">琼公网安备46010002001073号</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { sendSms,querySendDetails,forgotPwd,checkloginPhone,setImage,copyRight, getUserList  } from "@/api/xunyou";
import SIdentify from '@/components/sidentify'
import {getVerifyCode,sendSmsRegister} from "../api/xunyou";
import md5 from 'js-md5'
export default {
  name: 'login',
  components: { SIdentify },
  data() {
    return {
      informations:{},
      isShowButton:false,
      logo:'',
      //找回密码
      ruleForm: {
        username: '',
        code:'',
      },
      step:1,
      // 第二步
      secondruleForm:{
        codePhone:'',
        username:'',
        captcha: '', // 验证码
        // newPass:'',
        // checkPass:''
      },
      // 第三步
      numberruleForm:{
        newPass:'',
        checkPass:''
      },
      captcha: '', // 验证码
      verifyCode: '', //图形验证码
      uuid: '',
      bizId: '',
      sendTime:'',
      count: '',
      timer: null,
      sendCode: true,
      identifyCodes: "1234567890",
      identifyCode: "",
      merchantList: [], // 存储经销商列表
      selectedMerchantForm: {
        merchant: null
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        codePhone: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
        code: [{ required: true,
           trigger: ['blur'],
           validator:(rule, value, callback) => {
               if (value === '') {
                 callback(new Error('请输入验证码'));
               } else if (this.identifyCode !== value) {
                 callback(new Error('验证码错误'));
                 this.ruleForm.code ='',
                 this.refreshCode()
               }else{
                 callback();
               }
             }
           }],
        newPass:[{ required: true,
             //  message: "不能为空",
              trigger: ["blur"],
              validator:(rule, value, callback) => {
                 let reg = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                 let result = reg.test(value);
                 if (value == '') {
                     callback(new Error('不能为空'));
                 }else if (!result) {
                     callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                 }else{
                     callback();
                 }
              }
         }],
        checkPass:[{ required: true,
                // message: "不能为空",
                 trigger: ["blur"],
                validator:(rule, value, callback) => {
                    let regs = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                    let results = regs.test(value);
                    if (value == '') {
                      callback(new Error('不能为空'));
                    }else if (!results) {
                        callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                    }else if (value != this.numberruleForm.newPass ) {
                      callback(new Error('两次密码不一致'));
                    }else{
                      callback();
                    }
                }
        }],
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.$message({
    //   message: '账号密码及验证码不为空即可',
    //   type: 'success'
    // })
    // // 获取图形验证码
    // this.getcode()
    // // 获取存在本地的用户名密码
    // this.getuserpwd()
    this.getImagelogo()
    this.geTCopyright()
    this.getVerifyCode();
  },
  mounted(){
    this.makeCode(this.identifyCodes, 4);
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        console.log(res)
        if(res.code==0){
          this.informations = res.rows[0]
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },

    //获取LOGO
    getImagelogo(){
      setImage().then(res=>{
          if(res.code==0){
            this.logo = res.rows[0].pcLogo
          }
        })
    },
    //验证码
      randomNum(min, max) {
         return Math.floor(Math.random() * (max - min) + min);
      },

      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },

      makeCode(o, l) {
          for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
          ];
          }
      },
      // 下一步
      nextfoot(){
          this.$refs.ruleForm.validate(valid => {
                  if (valid) {
                    const req ={
                          phone: this.ruleForm.username,
                        }
                     checkloginPhone(req)
                      .then((res) => {
                          if (res.code == 0) {
                              if(res.data){
                                this.step = 2
                                this.secondruleForm.username = this.ruleForm.username
                              }else{
                                this.$message.error("用户不存在！");
                              }
                          }else{
                            this.$message.error(res.msg);
                          }
                      })
                      .catch((err) => {
                        this.$message.error("校验失败，请稍后再试！");
                      });
                  }
          })
      },
    secondfoot(){
      if(this.secondruleForm.codePhone.length != 6){
        this.$message.error("请输入正确的短信验证码");
        return;
      }
      this.$refs.secondruleForm.validate(valid => {
        if (valid) {
          const req = {
            phones: this.ruleForm.username,
            sendTime: this.sendTime,
            bizId: this.bizId,
            vcode: this.secondruleForm.codePhone
          };
          querySendDetails(req).then((res) => {
            if (res.code == 0) {
              // 校验通过，请求获取经销商列表
              return getUserList({ loginName: this.ruleForm.username, code: this.secondruleForm.codePhone, phones: this.ruleForm.username });
            } else {
              this.$message.error(res.msg);
            }
          }).then(merchantRes => {
            if (merchantRes && merchantRes.code === 0 && merchantRes.data && merchantRes.data.length > 1) {
              // 存储经销商列表并跳转到选择经销商页面或弹窗
              this.merchantList = merchantRes.data;
              this.step = 4; //  step=4 选择经销商页面
            } else {
              // 没有经销商，直接进入设置新密码页面
              this.step = 3;
            }
          }).catch((err) => {
            this.$message.error("校验失败，请稍后再试！");
          });
        }
      });
    },
      // 修改密码
       submitForm() {
          this.$refs.numberruleForm.validate(valid => {
              if (valid) {
                const req ={
                  phonenumber:this.ruleForm.username,
                  loginName: this.ruleForm.username,
                  password:this.numberruleForm.newPass,
                  userId: this.selectedMerchant ? this.selectedMerchant.muid : ''
                }
                 forgotPwd(req)
                      .then((res) => {
                          if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                               this.$router.push({ path: '/login' })
                          }else{
                            this.$message.error(res.msg);
                          }
                      })
                      .catch((err) => {
                        this.$message.error("修改失败，请稍后再试！");
                      });
              }
            })
      },
      // 获取图形验证码
      async getVerifyCode() {
        this.uuid = this.generateUUID(); // 生成 UUID
        try {
          const response = await getVerifyCode({ uuid: this.uuid });
          console.log('获取验证码响应', JSON.stringify(response))
          const blob = await response.data;
          this.verifyCode = URL.createObjectURL(blob); // 将 Blob 转换为 URL
        } catch (error) {
          console.error('获取验证码失败', error);
        }
      },
      generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      },
      // 获取短信验证码
    getsendSms(){
      sendSmsRegister({
        phoneNumbers: this.ruleForm.username,
        uuid: this.uuid,
        captcha: this.secondruleForm.captcha
      }).then((res) => {
        //  this.toast(res.Message);
        if (res.data.code !== 0) {
          this.$message({
            type: 'error',
            message: res.data.msg
          });
          return;
        } else {
          this.$message({
            type: 'success',
            message: '发送成功!'
          });
          //发送成功
          const bizId = res.data.BizId;
          this.bizId=bizId;
          var nowDate = new Date();
          var year = nowDate.getFullYear();
          var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
          var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
            .getDate();

          this.sendTime=year+''+month+''+day;

          const TIME_COUNT = 60;
          if (!this.timer) {
            this.isShowButton= true
            this.count = TIME_COUNT;
            this.sendCode = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.sendCode = true;
                this.isShowButton= false
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
        .catch((err) => {
          this.loading = false;
          this.$message.error("发送短信验证码失败，请稍后再试！");
        });
    },
    confirmMerchant() {
      const selected = this.selectedMerchantForm.merchant;
      if (!selected) {
        this.$message.warning('请选择一个经销商');
        return;
      }

      // 将选定的商户信息保存下来，用于后续提交密码时使用
      this.selectedMerchant = selected;

      // 跳转至设置新密码页
      this.step = 3;
    },
    // getsendSms(){
    //   sendSms({
    //       TemplateCode: 'SMS_180047841',
		// 			phoneNumbers: this.secondruleForm.username
    //   }).then((res) => {
    //     //  this.toast(res.Message);
		// 			if (res.data.Message !== 'OK') {
		// 				return;
		// 			} else {
    //         this.$message({
    //              type: 'success',
    //              message: '发送成功!'
    //          });
		// 				//发送成功
		// 				const bizId = res.data.BizId;
		// 				this.bizId=bizId;
		// 				var nowDate = new Date();
		// 				 var year = nowDate.getFullYear();
		// 				 var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
		// 				  : nowDate.getMonth() + 1;
		// 				 var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
		// 				  .getDate();
    //
		// 				this.sendTime=year+''+month+''+day;
    //
		// 				const TIME_COUNT = 60;
		// 				if (!this.timer) {
    //           this.isShowButton= true
		// 					this.count = TIME_COUNT;
		// 					this.sendCode = false;
		// 					this.timer = setInterval(() => {
		// 						if (this.count > 0 && this.count <= TIME_COUNT) {
		// 							this.count--;
		// 						} else {
    //               this.sendCode = true;
    //               this.isShowButton= false
		// 							clearInterval(this.timer);
		// 							this.timer = null;
		// 						}
		// 					}, 1000);
		// 				}
		// 			}
    //           })
    //           .catch((err) => {
    //             this.loading = false;
    //             this.$message.error("发送短信验证码失败，请稍后再试！");
    //           });
    // },
  }
}
</script>

<style scoped lang='less'>
/deep/ .logo img{
  width: 255px;
  height: 52px;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .header_logo {
      padding: 30px 140px;
      margin: auto;
  }
  .minddle{
    background: url("~@/assets/img/registerBackground.jpeg") no-repeat;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    height: 530px;
    .formBox {
       width: 450px;
       background: white;
       position: absolute;
       right: 180px;
       top: 120px;
       padding: 40px 50px;
       .codeImgText{
         .el-image.codeImg {
              width: 150px;
              height: 100%;
              cursor: pointer;
          }
          /deep/.el-input-group__append{
            padding: 0;
          }

       }
       .login_text {
         color: #666;
         margin-bottom: 20px;
         color: rgba(151, 152, 152, 0.6);
         font-size: 20px;
      }
      .find_text{
         color: #666;
         margin-bottom: 8px;
         color: rgba(151, 152, 152, 0.6);
         font-size: 20px;
      }
      button.el-button.el-button--primary {
          width: 100%;
          background-color: #394af8;
          border-color: #394af8;
      }
      button.el-button.el-button--primary:hover{
          background-color: #409eff;
          border-color: #409eff;
      }
      .textBox {
          text-align: right;
          font-size: 16px;
          a{
            color: #68b828;
            cursor: pointer;
          }
      }
       .getMessageText {
              display: block;
              // color: white;
              font-size: 16px;
              width: 170px;
              cursor: pointer;
              text-align: center;
          }
          /deep/.el-input-group__append {
             background: #4b5bff;
            color: white;
          }
          /deep/.el-input-group__append:hover {
              background: #5d6bff;
          }

    }
  }
  .footer_info {
    text-align: center;
    font-size: 14px;
    padding: 20px;
    p.text-center {
        color: #979898;
    }
  }
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.copyright_img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/retrievePassword.vue